export const AUTO_SIGNIN_STATUS_EMPTY = 'empty';
export const AUTO_SIGNIN_STATUS_PROCESSING = 'processing';
export const AUTO_SIGNIN_STATUS_FAILED = 'failed';
export const AUTO_SIGNIN_STATUS_AUTHORIZED = 'authorized';

export const isAutoSigninStatusEmpty = (status) => status === AUTO_SIGNIN_STATUS_EMPTY;
export const isAutoSigninStatusFailed = (status) => status === AUTO_SIGNIN_STATUS_FAILED;
export const isAutoSigninStatusProcessing = (status) => status === AUTO_SIGNIN_STATUS_PROCESSING;
export const isAutoSigninStatusAuthorized = (status) => status === AUTO_SIGNIN_STATUS_AUTHORIZED;
